import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import './assets/style/base.css';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import './theme/index.css';
import http from './http/request';

import api from './http/interface'; //接口重新统一管理
Vue.prototype.$api = api;   //接口重新统一管理
// import config from './http/config';

Vue.prototype.$http = http;
Vue.use(ElementUI);

import print from 'print-js'
Vue.prototype.$print = print;



Vue.config.productionTip = false;


import utils from './utils/utils';
Vue.prototype.$utils = utils;


//接口模块化统一管理后this.common清空，页面中所有的this.common可删除， 原因：开发使用了代理，生成环境有baseurl，兼容页面写死的接口和后期模块化的接口
Vue.prototype.common = {  
  admin: '',
  company: '',
  imgUrl: '',
}

//旧有代码，适配页面中this.common
// if (process.env.NODE_ENV == 'production') {
//   //生产环境
//   // axios.defaults.baseURL = '' 
//   Vue.prototype.common = {

//     //公司测试
//     // admin: 'https://api.chinazby.cn/charge/public/index.php',
//     // company: 'https://api.chinazby.cn/charge/public/index.php',
//     // imgUrl: 'https://api.chinazby.cn/charge/public',

//     //客户开发
//     // admin: 'https://api.cheanbao.cn/dev_api/public/index.php',
//     // company: 'https://api.cheanbao.cn/dev_api/public/index.php',
//     // imgUrl: 'https://api.cheanbao.cn/dev_api/public',
    
//     //客户正式
//     // admin: 'https://api.cheanbao.cn/api/public/index.php',
//     // company: 'https://api.cheanbao.cn/api/public/index.php',
//     // imgUrl: 'https://api.cheanbao.cn/api/public',
//   }
// } else {
//   //开发环境
//   Vue.prototype.common = {
//     admin: '/admin',
//     company: '/company',
//     imgUrl: '/imgUrl',
//   }
// }

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
